import React, { FC } from "react";

const ChevronsLeft: FC = () => {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.989 6.0691L19.2735 4.35359C19.0782 4.15833 18.7617 4.15833 18.5664 4.35359L11.3535 11.5665C11.1582 11.7617 11.1582 12.0783 11.3535 12.2736L18.5664 19.4865C18.7617 19.6817 19.0777 19.6822 19.273 19.487L20.9943 17.7657C21.1865 17.5735 21.1897 17.2631 21.0018 17.0667L16 11.84L20.9916 6.77357C21.1844 6.57789 21.1833 6.26334 20.989 6.0691ZM13.9889 6.06905L12.2734 4.35354C12.0782 4.15827 11.7616 4.15827 11.5663 4.35354L4.35343 11.5664C4.15817 11.7617 4.15817 12.0783 4.35343 12.2735L11.5663 19.4864C11.7616 19.6817 12.0777 19.6822 12.2729 19.4869L13.9942 17.7657C14.1864 17.5734 14.1897 17.263 14.0017 17.0666L8.99991 11.84L13.9916 6.77352C14.1844 6.57784 14.1832 6.26329 13.9889 6.06905Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default React.memo(ChevronsLeft);
